<template>
  <span v-if="modelValue" class="font-extrabold text-red-500 text-xl">
    <sup>*</sup>
  </span>
</template>

<script lang="ts" setup>

withDefaults(defineProps<{
	modelValue: boolean
}>(), {
	modelValue: false,
})
</script>
